import React from 'react';

const NoDataMessage = () => (
  <div style={{ textAlign: 'center', padding: '20px', color: '#fff' }}>No data available</div>
);

export default NoDataMessage;